'use strict'

const _ = require('lodash')

function getCompDef(item) {
    return {
        "layout": {
            "width": 120,
            "height": 120,
            "scale": 1,
            "rotationInDegrees": 0,
            "fixedPosition": false
        },
        "props": {
            "type": "VectorImageProperties",
            "metaData": {
                "schemaVersion": "1.0"
            },
            "displayMode": 'fit'
        },
        "skin": "skins.viewer.VectorImageSkin",
        "componentType": "wysiwyg.viewer.components.VectorImage",
        "data": {
            "type": "VectorImage",
            "metaData": {"isPreset": false, "schemaVersion": "1.0", "isHidden": false},
            "svgId": item.uri
        },
        "design": {
            "type": "VectorImageDesignData",
            "metaData": {"isPreset": false, "schemaVersion": "1.0", "isHidden": false},
            "shapeStyle": {
                "opacity": 1,
                "strokeOpacity": 1,
                "stroke": "#5E97FF",
                "strokeWidth": 4,
                "enableStroke": false

            },
            "overrideColors": {
                "color1": "#242323"
            }
        },
        "style": {
            "type": "TopLevelStyle",
            "metaData": {"isPreset": false, "schemaVersion": "1.0", "isHidden": false},
            "style": {
                "groups": {},
                "properties": {},
                "propertiesSource": {}
            },
            "componentClassName": "wysiwyg.viewer.components.VectorImage",
            "styleType": "custom",
            "skin": "skins.viewer.VectorImageSkin"
        }
    }
}

function onItemsSelected(props, editorAPI, items, info) {
    _.forEach(items, function (item) {
        props.onClick(getCompDef(item), props.sectionTitle, '')
        editorAPI.store.dispatch(props.setSessionUserPreferences(`last_media_path_${item.uri}`, info.path))
    })
}

module.exports = function (editorAPI, props) {
    const category = editorAPI.mediaServices.mediaManager.categories[props.category]
    editorAPI.bi.event(props.addPanelBiEvent.ADD_MENU_MORE_CLICK, {
        category: props.categoryId,
        section: props.sectionName
    })
    editorAPI.mediaServices.mediaManager.open(category, props.openSource, {
        multiSelect: true,
        callback: function (items, info) {
            onItemsSelected(props, editorAPI, items, info)
        },
        path: props.path
    })
}
